/** add parents back for serialized objects */
function deepAddParent(obj, parent) {
    if (parent) {
        obj.parent = parent;
    }
    for (const c of obj.children) {
        deepAddParent(c, obj);
    }
    return obj;
}

export { deepAddParent };
//# sourceMappingURL=deep-add-parent.js.map
